import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconBrandTelegram } from '@tabler/icons-react';
import { lazy } from 'react';
import { AuthController } from '@ayocore/platform/identity/client/AuthController';
import { registerTelegramIdentityExtension } from './extensions/TelegramIdentityExtension';

/**
 * Бутстрап модуля Telegram (клиент).
 * Регистрирует расширения и страницу управления ботами (только для администраторов).
 */
export async function setup(app: AppRuntime): Promise<void> {
  // Расширения регистрируются до инициализации навигации
  registerTelegramIdentityExtension();

  const telegram = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  telegram.useNavigation([
    {
      icon: IconBrandTelegram,
      label: 'Telegram боты',
      url: '/telegram/bots',
      component: lazy(() => import('./components/BotsList')),
      guard: () => {
        const user = AuthController.getInstance().getSnapshot().user;
        return user?.roles?.includes('ADMIN') ?? false;
      },
    },
  ]);
}
